<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uSJ9H3/tc-custom/9781488046148.jpg?1701060599082" alt="This image is the cover for the book Marshal on a Mission, American Armor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marshal on a Mission, American Armor
      </h1>
      <p class="bookDescription body article font2">
        <b>In this romantic suspense, a lawman goes on witness protection duty when the woman in need of safeguarding is the girl whose heart he broke in high school</b>.<br/><br/>After witnessing an armed bank robbery, Tara Munroe is forced to go on the run. A ruthless gang determined to silence her stalks her from Colorado to Mexico. Thankfully, US Marshal Trent Nielsen isn’t far behind and vows to bring her home . . . whatever it takes. But once Trent catches up with her, he has to face down the feelings he’s long held for Tara. Which makes his mission to protect her tougher, even for this seasoned lawman. With no shortage of men gunning for them, he’ll have to stay one step ahead if he has any chance of keeping Tara alive.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ryshia Kennie
      </h2>
      
      <p class="authorDescription body article">Ryshia Kennie is the award-winning author of her city’s writing award and a semi-finalist in the Kindle Book Awards. There’s never a lack of intriguing places to set an edge-of-the-seat suspense as prairie winters find her dreaming of foreign shores. Those places become the catalyst for heart-stopping stories with deadly villains threatening intrepid heroes and heroines, who battle for their right to live or even to love, in a place that neither - or both, may call home.  www.ryshiakennie.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ef276cb